import { url, tokenRef } from "api";

// ==================== HELPERS ====================
const getHeaders = () => {
  const headers = {
    "Content-Type": "application/json",
  };

  const userToken = localStorage.getItem(tokenRef);
  if (userToken) {
    headers["Authorization"] = `Bearer ${userToken}`;
  }

  return headers;
};

const handleResponse = async (response) => {
  const data = await response.json();
  if (!response.ok) {
    const error = new Error(data.err || "Request failed");
    error.status = response.status;
    error.data = data;
    throw error;
  }
  return data;
};

// ==================== RESPONSIBLE INVITES ====================

/**
 * Owner-side: invite a responsible person by email.
 * → 201 {invite, emailSent, registrationUrl?}
 * → 200 {existingUser:true, userId} when the email already has an account
 */
export const inviteResponsible = async (projectId, email, issueIds) => {
  const response = await fetch(
    `${url}/projects/${projectId}/responsible-invites`,
    {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify({ email, issueIds: issueIds || [] }),
    }
  );
  return handleResponse(response);
};

/**
 * PUBLIC (no auth header): registration-page context for an invite token.
 * → {email, projectTitle, issues:[{_id,displayId,title,priority,location}],
 *    expiresAt}
 * Errors carry .status: 409 already used, 410 expired.
 */
export const getInviteContext = async (token) => {
  const response = await fetch(`${url}/responsible-invites/${token}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  return handleResponse(response);
};

/**
 * PUBLIC (no auth header): register from an invite.
 * body: {companyName, name, lastName?, password, confirmNewCompany?}
 * → 201 {success,...}
 * → 409 {err:'similar_companies_found', suggestions:[...]} (on error.data)
 */
export const registerResponsible = async (token, body) => {
  const response = await fetch(
    `${url}/responsible-invites/${token}/register`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }
  );
  return handleResponse(response);
};
